import React, { createContext, useState, useEffect } from "react";

// Create the context
export const LocalStorageContext = createContext(null);

// Create the provider component
export const LocalStorageProvider = ({ children }) => {
    const [userData, setUserData] = useState(() => {
        // Initialize from localStorage
        const storedData = localStorage.getItem("auth");
        return storedData ? JSON.parse(storedData) : null;
    });

    // Function to update both state and localStorage
    const updateUserData = (data) => {
        localStorage.setItem("auth", JSON.stringify(data));
        setUserData(data);
    };

    // You can add more localStorage items as needed
    const [preferences, setPreferences] = useState(() => {
        const storedPrefs = localStorage.getItem("preferences");
        return storedPrefs ? JSON.parse(storedPrefs) : { theme: "light" };
    });

    const updatePreferences = (prefs) => {
        localStorage.setItem("preferences", JSON.stringify(prefs));
        setPreferences(prefs);
    };

    // Value to be provided by the context
    const contextValue = {
        userData,
        updateUserData,
        preferences,
        updatePreferences,
        // Add more localStorage-related state and update functions as needed
    };

    return <LocalStorageContext.Provider value={contextValue}>{children}</LocalStorageContext.Provider>;
};
